import { jwtDecode } from "jwt-decode";
import moment from "moment";

export const getDecodedToken = () => {
  const token = localStorage.getItem("token");
  return token ? jwtDecode(token) : null;
};

export const betCheckData = [
  {
    value: "4",
    label: "Cricket",
  },
  {
    value: "2",
    label: "Tennis",
  },
  {
    value: "1",
    label: "Soccer",
  },
  {
    value: "3",
    label: "Casino",
  },
];

export const betCheckDataInner = [
  {
    value: "betfair",
    label: "Bet Fair",
  },
  {
    value: "bookmaker",
    label: "Bookmaker",
  },
  {
    value: "fancy",
    label: "Fancy",
  },
  {
    value: "sportBook",
    label: "SportsBook",
  },
  {
    value: "parlay",
    label: "Parly",
  },
  {
    value: "HorseRacing",
    label: "Horse Racing",
  },
  {
    value: "GreyhoundRacing",
    label: "Greyhound Racing",
  },
  {
    value: "Kabaddi",
    label: "Kabaddi",
  },
  {
    value: "Election",
    label: "Election",
  },
];
export const betCheckObj = {
  4: "Cricket",
  2: "Tennis",
  1: "Soccer",
  3: "Casino",
};
export const formatDate = (date) => {
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
};
export function toFixedWithoutRounding(num, decimals = 2) {
  const number = Number(num);
  if (isNaN(number)) return (0).toFixed(decimals);

  const isNegative = number < 0;
  const str = Math.abs(number).toString();

  if (str.includes("e")) {
    return number.toFixed(decimals);
  }

  const decimalIndex = str.indexOf(".");
  let result;

  if (decimalIndex === -1) {
    result = str + "." + "0".repeat(decimals);
  } else {
    const fixed = str.substring(0, decimalIndex + decimals + 1);
    const decimalPart = fixed.split(".")[1] || "";
    result = fixed + "0".repeat(Math.max(0, decimals - decimalPart.length));
  }

  return isNegative ? "-" + result : result;

  // const n =
  //   typeof num === "string"
  //     ? Number(num.replace(/,/g, "").trim())
  //     : Number(num);

  // if (!Number.isFinite(n)) return "0.00";

  // // remove float noise: 0.7999999999999999 -> 0.8
  // const clean = Number(n.toPrecision(15));

  // const s = clean.toLocaleString("en-US", {
  //   useGrouping: false,
  //   maximumFractionDigits: 20,
  // });

  // const [int, frac = ""] = s.split(".");
  // const out = `${int}.${frac.slice(0, 2).padEnd(2, "0")}`;

  // return out === "-0.00" ? "0.00" : out;
}

function getAlertContainer() {
  let c = document.querySelector(".vk-alert-container");
  if (!c) {
    c = document.createElement("div");
    c.className = "vk-alert-container";
    document.body.appendChild(c);
  }
  return c;
}

/**
 * @param {string} message
 * @param {number} duration ms
 * @param {"success"|"error"|"info"|"warning"} type
 */
export function showAlert(message, duration = 2000, type = "success") {
  const box = document.createElement("div");
  box.className = `vk-alert vk-alert--${type}`;
  box.setAttribute("role", "alert");
  box.textContent = message;

  getAlertContainer().appendChild(box);

  requestAnimationFrame(() => box.classList.add("vk-alert--visible"));

  const remove = () => {
    box.classList.remove("vk-alert--visible");
    setTimeout(() => box.remove(), 300);
  };

  const timer = setTimeout(remove, duration);
  box.addEventListener("click", () => {
    clearTimeout(timer);
    remove();
  });
}

export const currencyFormat = (num, decimals = 2) => {
  //     const factor = Math.pow(10, decimals);
  // return Math.trunc(num * factor) / factor;

  const number = Number(num);
  if (isNaN(number)) return (0).toFixed(decimals);

  const isNegative = number < 0;
  const str = Math.abs(number).toString();

  if (str.includes("e")) {
    return number.toFixed(decimals);
  }

  const decimalIndex = str.indexOf(".");
  let result;

  if (decimalIndex === -1) {
    result = str + "." + "0".repeat(decimals);
  } else {
    const fixed = str.substring(0, decimalIndex + decimals + 1);
    const decimalPart = fixed.split(".")[1] || "";
    result = fixed + "0".repeat(Math.max(0, decimals - decimalPart.length));
  }

  return isNegative ? "-" + result : result;
};

export const levelMap = {
  owner: "lv_1",
  sub_owner: "lv_2",
  super_admin: "lv_3",
  admin: "lv_4",
  sub_admin: "lv_5",
  senior_super: "lv_6",
  super_agent: "lv_7",
  agent: "lv_8",
  user: "lv_9",
};

// export const user_status = {
//   owner: "OW",
//   sub_owner: "SOW",
//   super_admin: "OW",
//   admin: "WL",
//   sub_admin: "AD",
//   senior_super: "SA",
//   super_agent: "SM",
//   agent: "MA",
//   user: "PL",
// };
export const user_status_new = {
  owner: "OW",
  sub_owner: "SOW",
  super_admin: "OW",
  admin: "WL",
  sub_admin: "AD",
  senior_super: "SA",
  super_agent: "SM",
  agent: "MA",
  user: "PL",
};

export const layerPanel1 = {
  sub_owner: "WL",
  super_admin: "Admin",
  admin: "Senior Sub Admin",
  sub_admin: "Sub Admin",
  senior_super: "Super",
  super_agent: "Master",
  agent: "Player",
};
export const role = {
  sub_owner: 8,
  super_admin: 7,
  admin: 6,
  sub_admin: 5,
  senior_super: 4,
  super_agent: 3,
  agent: 2,
  user: 1,
};

export const user_next_status = {
  owner: "sub_owner",
  sub_owner: "super_admin",
  super_admin: "admin",
  admin: "sub_admin",
  sub_admin: "senior_super",
  senior_super: "super_agent",
  super_agent: "agent",
  agent: "user",
};
// const levelMap = {
//   MAIN: "lv_1",
//   WL: "lv_2",
//   AD: "lv_3",
//   SA: "lv_4",
//   SM: "lv_5",
//   MA: "lv_6",
//   AG: "lv_7",
//   PL: "lv_8",
// };
export const user_status = {
  owner: "OW",
  sub_owner: "SOW",
  super_admin: "OW",
  admin: "WL",
  sub_admin: "AD",
  senior_super: "SA",
  super_agent: "SM",
  agent: "MA",
  user: "PL",
};

const HIERARCHY = [
  { key: "sub_owner", value: "SOW", name: "Sub Owner", layer: 2 },
  { key: "super_admin", value: "OW", name: "Owner", layer: 3 },
  { key: "admin", value: "WL", name: "WL", layer: 4 },
  { key: "sub_admin", value: "AD", name: "Admin", layer: 5 },
  { key: "senior_super", value: "SA", name: "Sub Admin", layer: 6 },
  { key: "super_agent", value: "SM", name: "Super", layer: 7 },
  { key: "agent", value: "MA", name: "Master", layer: 8 },
];

export const LayerUserText = {
  2: "Sub Owner",
  3: "Owner",
  4: "WL",
  5: "Admin",
  6: "Sub Admin",
  7: "Super",
  8: "Master",
};

export const LayerUser = {
  sub_owner: 2,
  super_admin: 3,
  admin: 4,
  sub_admin: 5,
  senior_super: 6,
  super_agent: 7,
  agent: 8,
};
export const LayerUserNumber = {
  2: "sub_owner",
  3: "super_admin",
  4: "admin",
  5: "sub_admin",
  6: "senior_super",
  7: "super_agent",
  8: "agent",
};

export const DownlineHeader = (type) => {
  if (type === "agent") {
    return [{ key: "user", value: "PL", name: "User", layer: 8 }];
  }

  const startIndex = HIERARCHY.findIndex((item) => item.key === type) + 1;

  if (startIndex <= 0) return [];

  return HIERARCHY.slice(startIndex);
};
